import type { SVGProps } from 'react'
const SvgReadOnly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="267"
    height="157"
    viewBox="0 0 267 157"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12557_27033)">
      <path d="M266.5 147.577H0.5V147.689H266.5V147.577Z" fill="#F7F7F7" />
      <path
        d="M239.846 154.823H222.227V154.935H239.846V154.823Z"
        fill="#F7F7F7"
      />
      <path
        d="M176.709 156.048H172.086V156.161H176.709V156.048Z"
        fill="#F7F7F7"
      />
      <path
        d="M221.695 150.644H211.486V150.756H221.695V150.644Z"
        fill="#F7F7F7"
      />
      <path d="M51.3858 151.4H28.4087V151.512H51.3858V151.4Z" fill="#F7F7F7" />
      <path d="M59.4935 151.4H56.126V151.512H59.4935V151.4Z" fill="#F7F7F7" />
      <path d="M120.28 153.3H70.4419V153.413H120.28V153.3Z" fill="#F7F7F7" />
      <path
        d="M126.589 127.491H23.86C22.1842 127.491 20.8223 126.338 20.8223 124.919V2.68065C20.8223 1.26204 22.1842 0.109146 23.86 0.109146H126.589C128.265 0.109146 129.627 1.26204 129.627 2.68065V124.919C129.627 126.338 128.265 127.491 126.589 127.491ZM23.86 0.221734C22.2587 0.221734 20.9553 1.32509 20.9553 2.68065V124.919C20.9553 126.275 22.2587 127.378 23.86 127.378H126.589C128.191 127.378 129.494 126.275 129.494 124.919V2.68065C129.494 1.32509 128.191 0.221734 126.589 0.221734H23.86Z"
        fill="#F7F7F7"
      />
      <path
        d="M241.661 127.491H138.932C137.256 127.491 135.894 126.338 135.894 124.919V2.68065C135.894 1.26204 137.256 0.109146 138.932 0.109146H241.661C243.337 0.109146 244.699 1.26204 244.699 2.68065V124.919C244.699 126.338 243.337 127.491 241.661 127.491ZM138.932 0.221734C137.33 0.221734 136.027 1.32509 136.027 2.68065V124.919C136.027 126.275 137.33 127.378 138.932 127.378H241.661C243.262 127.378 244.566 126.275 244.566 124.919V2.68065C244.566 1.32509 243.262 0.221734 241.661 0.221734H138.932Z"
        fill="#F7F7F7"
      />
      <path
        d="M133.5 156.498C190.468 156.498 236.65 153.783 236.65 150.433C236.65 147.083 190.468 144.367 133.5 144.367C76.5322 144.367 30.3506 147.083 30.3506 150.433C30.3506 153.783 76.5322 156.498 133.5 156.498Z"
        fill="#E6F2FE"
      />
      <path
        d="M222.03 14.8482H44.9697C40.6183 14.8482 37.0908 18.401 37.0908 22.7836V136.8C37.0908 141.183 40.6183 144.736 44.9697 144.736H222.03C226.381 144.736 229.909 141.183 229.909 136.8V22.7836C229.909 18.401 226.381 14.8482 222.03 14.8482Z"
        fill="white"
      />
      <path
        d="M222.03 145.025H44.9694C40.4687 145.025 36.8032 141.333 36.8032 136.8V22.7839C36.8032 18.2509 40.4687 14.5591 44.9694 14.5591H222.035C226.536 14.5591 230.201 18.2509 230.201 22.7839V136.8C230.201 141.333 226.536 145.025 222.035 145.025H222.03ZM44.9694 15.1378C40.7826 15.1378 37.3778 18.567 37.3778 22.7839V136.8C37.3778 141.017 40.7826 144.447 44.9694 144.447H222.035C226.222 144.447 229.627 141.017 229.627 136.8V22.7839C229.627 18.567 226.222 15.1378 222.035 15.1378H44.9694Z"
        fill="#66B0F6"
      />
      <path
        d="M52.3267 23.2074C52.3267 24.6219 51.1883 25.7632 49.7891 25.7632C48.3899 25.7632 47.2515 24.6166 47.2515 23.2074C47.2515 21.7982 48.3899 20.6515 49.7891 20.6515C51.1883 20.6515 52.3267 21.7982 52.3267 23.2074Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M69.0004 24.7024H56.5409C55.7216 24.7024 55.0566 24.0273 55.0566 23.2075C55.0566 22.3823 55.727 21.7125 56.5409 21.7125H69.0004C69.8196 21.7125 70.4846 22.3877 70.4846 23.2075C70.4846 24.0326 69.8143 24.7024 69.0004 24.7024Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M129.063 24.0275H120.322C119.87 24.0275 119.508 23.6578 119.508 23.2077C119.508 22.7522 119.875 22.3879 120.322 22.3879H129.063C129.515 22.3879 129.876 22.7576 129.876 23.2077C129.876 23.6631 129.509 24.0275 129.063 24.0275Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M148.678 24.0275H139.937C139.485 24.0275 139.123 23.6578 139.123 23.2077C139.123 22.7522 139.49 22.3879 139.937 22.3879H148.678C149.13 22.3879 149.492 22.7576 149.492 23.2077C149.492 23.6631 149.125 24.0275 148.678 24.0275Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M168.293 24.0275H159.552C159.1 24.0275 158.738 23.6578 158.738 23.2077C158.738 22.7522 159.105 22.3879 159.552 22.3879H168.293C168.745 22.3879 169.106 22.7576 169.106 23.2077C169.106 23.6631 168.739 24.0275 168.293 24.0275Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M187.913 24.0275H179.172C178.72 24.0275 178.358 23.6578 178.358 23.2077C178.358 22.7522 178.725 22.3879 179.172 22.3879H187.913C188.365 22.3879 188.727 22.7576 188.727 23.2077C188.727 23.6631 188.36 24.0275 187.913 24.0275Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.7"
        d="M213.013 24.6542H199.787C198.994 24.6542 198.351 24.0059 198.351 23.2075C198.351 22.4092 198.994 21.7608 199.787 21.7608H213.013C213.805 21.7608 214.449 22.4092 214.449 23.2075C214.449 24.0059 213.805 24.6542 213.013 24.6542Z"
        fill="#C8C8C8"
      />
      <path
        d="M205.524 46.0843L60.2753 46.0057C54.4893 46.0025 49.7578 46.306 49.7072 46.6834L48.0919 58.7355C48.0413 59.1129 52.6907 59.4214 58.4768 59.4245L203.725 59.5031C209.511 59.5063 214.242 59.2028 214.293 58.8254L215.908 46.7733C215.959 46.3959 211.31 46.0874 205.524 46.0843Z"
        fill="#F7F7F7"
      />
      <path
        d="M205.524 61.5931L60.2753 61.5145C54.4893 61.5113 49.7578 61.8148 49.7072 62.1922L48.0919 74.2443C48.0413 74.6217 52.6907 74.9302 58.4768 74.9333L203.725 75.0119C209.511 75.015 214.242 74.7116 214.293 74.3342L215.908 62.2821C215.959 61.9047 211.31 61.5962 205.524 61.5931Z"
        fill="#F7F7F7"
      />
      <path
        d="M205.524 77.1018L60.2753 77.0232C54.4893 77.0201 49.7578 77.3235 49.7072 77.701L48.0919 89.753C48.0413 90.1305 52.6907 90.439 58.4768 90.4421L203.725 90.5207C209.511 90.5238 214.242 90.2204 214.293 89.843L215.908 77.7909C215.959 77.4135 211.31 77.105 205.524 77.1018Z"
        fill="#F7F7F7"
      />
      <path
        d="M205.523 92.6106L60.2748 92.532C54.4888 92.5289 49.7573 92.8323 49.7067 93.2098L48.0914 105.262C48.0408 105.639 52.6903 105.948 58.4763 105.951L203.724 106.029C209.511 106.033 214.242 105.729 214.293 105.352L215.908 93.2997C215.959 92.9223 211.309 92.6138 205.523 92.6106Z"
        fill="#F7F7F7"
      />
      <path
        d="M205.523 108.119L60.2748 108.041C54.4888 108.038 49.7573 108.341 49.7067 108.719L48.0914 120.771C48.0408 121.148 52.6903 121.457 58.4763 121.46L203.724 121.538C209.511 121.541 214.242 121.238 214.293 120.861L215.908 108.808C215.959 108.431 211.309 108.123 205.523 108.119Z"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_12557_27033">
        <rect
          width="266"
          height="157"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgReadOnly
